import React, { useEffect, useState } from "react";
import "../Login/Style.css"
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Spin, message } from "antd";
import axios from "axios";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      // const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const currentTime = Math.floor(Date.now() / 1000); 
      const tokenExp = JSON.parse(atob(token.split(".")[1])).exp; 
      if (tokenExp > currentTime) {
        navigate("/dashboard"); 
      } else {
        sessionStorage.clear(); 
      }
    }
  }, [navigate]);
  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/super-admin/login`, values);
      
      const { token, userDetails } = response.data;
      sessionStorage.setItem("authToken", token);
      sessionStorage.setItem("userDetails", JSON.stringify(userDetails));

      message.success("Login successful!");
      navigate("/dashboard");
    } catch (error) {
      message.error(error.response?.data?.message || "Login failed!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "50px auto", textAlign: "center" }}>
      <h2>Login</h2>
      <Spin spinning={loading}>
        <Form
          name="login"
          onFinish={onFinish}
          layout="vertical"
          initialValues={{ email: "", password: "" }}
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please enter your email!" },
              { type: "email", message: "Please enter a valid email!" },
            ]}
          >
            <Input placeholder="Enter your email" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please enter your password!" }]}
          >
            <Input.Password placeholder="Enter your password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Login
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};

export default Login;
